import axios from 'axios';
import { API_BASE_URL } from './apiConfig';

function getAuthHeaders() {
  const token = localStorage.getItem('access_token');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
}

// Mock notifications for development (remove when backend is ready)
// const mockNotifications = [
//   {
//     id: 1,
//     title: 'New Patient Registration',
//     message: 'John Doe has registered as a new patient.',
//     read_at: null,
//     created_at: new Date(Date.now() - 1000 * 60 * 30).toISOString(), // 30 minutes ago
//     priority: 'medium',
//     category: 'patient'
//   },
//   {
//     id: 2,
//     title: 'Appointment Reminder',
//     message: 'Reminder: You have an appointment with Sarah Smith in 2 hours.',
//     read_at: null,
//     created_at: new Date(Date.now() - 1000 * 60 * 60).toISOString(), // 1 hour ago
//     priority: 'high',
//     category: 'appointment'
//   },
//   {
//     id: 3,
//     title: 'System Update',
//     message: 'Your clinic dashboard has been updated with new features.',
//     read_at: new Date().toISOString(), // Read
//     created_at: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(), // 1 day ago
//     priority: 'low',
//     category: 'system'
//   }
// ];

// Get notifications with optional filter
export async function getNotifications(userId, filter = 'all') {
  try {
    // Convert frontend filter to backend parameters
    const params = { 
      _t: Date.now() // Cache busting parameter
    };
    
    // Handle different filter types
    if (filter && filter.read === false) {
      params.read = false; // Show only unread
    } else if (filter && filter.read === true) {
      params.read = true;  // Show only read
    }
    
    if (filter && filter.category) {
      params.category = filter.category;
    }
    
    if (filter && filter.priority) {
      params.priority = filter.priority;
    }
    
    const response = await axios.get(`${API_BASE_URL}/api/notifications`, {
      params,
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    
    return response.data.notifications || [];
  } catch (error) {
    console.log('Using mock notifications (backend endpoint not available)');
    console.error('Notification API error:', error);
    
    // Return empty array instead of mock data
    return [];
  }
}

// Mark notification as read
export async function markNotificationAsRead(notificationId) {
  try {
    await axios.patch(`${API_BASE_URL}/api/notifications/${notificationId}/read`, {}, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    return true;
  } catch (error) {
    console.error('Error marking notification as read:', error);
    return false;
  }
}

// Mark all notifications as read
export async function markAllNotificationsAsRead() {
  try {
    const response = await axios.post(`${API_BASE_URL}/api/notifications/mark-all-read`, {}, {
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    console.log('✅ Mark all as read API response:', response.data);
    return response.data?.success !== false; // Return true if success is not false
  } catch (error) {
    console.error('❌ Error marking all notifications as read:', error);
    if (error.response) {
      console.error('❌ Response data:', error.response.data);
      console.error('❌ Response status:', error.response.status);
    }
    return false;
  }
}

// Get unread notifications count
export async function getUnreadCount() {
  try {
    const response = await axios.get(`${API_BASE_URL}/api/notifications/unread-count`, {
      params: { _t: Date.now() }, // Cache busting parameter
      headers: getAuthHeaders(),
      withCredentials: true,
    });
    return response.data.unread_count || 0;
  } catch (error) {
    console.log('Using mock unread count (backend endpoint not available)');
    console.error('Unread count API error:', error);
    return 0;
  }
} 